import { createContext, useContext } from 'react'

export type UserDetailsContextType = {
    userID: string
}

export const UserDetailsContext = createContext<UserDetailsContextType | undefined>(undefined)

export const useUserDetails = () => {
    const userDetails = useContext(UserDetailsContext)
    return userDetails
}

export const UserDetailsProvider = UserDetailsContext.Provider
